import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { productServices } from '@hero/services';
import { createQueryKey } from '@hero/utils';

export const useGetCategories = (params = {}, options = {}) =>
  useQuery(
    createQueryKey(QUERY_KEYS.useGetCategoriesKey, params),
    () => productServices.getCategories(params),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      ...options
    }
  );
